import { createStyles, DESKTOP_HEADER_HEIGHT, rem } from '@affstore-ds/uikit'

export const useErrorPageStyles = createStyles((theme, { isOuterErrorPath }: { isOuterErrorPath: boolean }) => ({
  pageContainer: {
    width: '100%',
    alignItems: 'center',
    display: 'flex',
    height: isOuterErrorPath ? '100vh' : `calc(${theme.other.viewport.height} - ${rem(DESKTOP_HEADER_HEIGHT * 2)})`,
    justifyContent: 'center',
  },
}))
